import { useState } from "react";
import { t } from "@lingui/macro";
import { Button, DatePicker, Input, Select } from "antd";
import { UndoOutlined } from "@ant-design/icons";
import { translate } from "utils";
import moment, { Moment } from "moment";
import SelectInfinity from "components/select-infinity/SelectInfinity";
import {
	SUBSCRIPTION_TRANSACTION_STATUS,
	SubscriptionTransactionQueryParams,
} from "features/subscription-transaction/type";
import { Merchant } from "features/merchant/types";
import { getMerchantsAPI } from "service/apis";
import { MerchantQuery } from "service/queries";
import { subscriptionTransactionStatus } from "features/subscription-transaction/constants";
const { Option } = Select;
const { RangePicker } = DatePicker;
export interface SearchParams {
	query: SubscriptionTransactionQueryParams;
	setQuery: (query: SubscriptionTransactionQueryParams) => void;
	getList: (query: SubscriptionTransactionQueryParams) => void;
}
export const subscriptionTransactionDefaultQuery: SubscriptionTransactionQueryParams =
	{ skip: 0, take: 10, status: null };
const Search = ({ query, setQuery, getList }: SearchParams) => {
	const { createdAtFrom: startDate, createdAtTo: endDate } = query;

	const [queryMerchant, setQueryMerchant] = useState({
		skip: 0,
		take: 10,
		total: 0,
	});
	const [merchants, setMerchants] = useState<Merchant[]>([]);

	const handleSearchMerchant = (searchValue: string) => {
		/* @ts-ignore */
		setQueryMerchant((prev: MerchantQuery) => {
			if (searchValue) {
				return {
					...prev,
					skip: 0,
					fullName: searchValue,
				};
			} else {
				const prevState = prev;
				delete prevState.fullName;
				return {
					...prevState,
					skip: 0,
				};
			}
		});
	};
	const handleChangeMerchant = (merchantName: string) => {
		const newQuery = {
			...query,
			merchantId:
				merchants.find(el => (merchantName || "").indexOf(el.fullName!) === 0)
					?.id || null,
			merchantName,
		};
		getList(newQuery);
	};
	const handleChangeQuery = (
		key: keyof SubscriptionTransactionQueryParams,
		value: string | number,
	) => {
		const newQuery = {
			...query,
			[key]: value,
		};
		getList(newQuery);
	};
	const handleChangeSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
		setQuery({
			...query,
			[event.target.name]: event.target.value,
		});
	};
	const handleSearch = (value: string) => handleChangeQuery("id", value);

	const handleReset = () => {
		getList(subscriptionTransactionDefaultQuery);
	};

	const handleChangeStatus = (value: SUBSCRIPTION_TRANSACTION_STATUS) =>
		handleChangeQuery("status", value);
	const handleChangeRangeDate = (
		values: [Moment | null, Moment | null] | null,
	) => {
		const [start, end] = values || [];

		const newQuery = {
			...query,
			createdAtFrom: start?.toISOString(),
			createdAtTo: end?.toISOString(),
			skip: 0,
		};

		getList(newQuery);
	};
	const getLabelByType = (value?: string) => {
		if (!value) return translate("All");
		return value?.toString();
	};
	return (
		<div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 2xl:grid-cols-5 gap-4 mt-5">
			<div>
				<p>{t`Transaction ID`}</p>
				<Input.Search
					placeholder={t`Transaction ID`}
					onSearch={handleSearch}
					onChange={handleChangeSearch}
					value={query.id || ""}
					name="id"
				/>
			</div>
			<div>
				<p>{translate("Merchant")}</p>
				<SelectInfinity
					query={queryMerchant}
					setQuery={setQueryMerchant}
					renderList={merchants}
					setRenderList={setMerchants}
					fetchMoreFunc={getMerchantsAPI}
					onSearch={handleSearchMerchant}
					onChange={handleChangeMerchant}
					placeholder={translate("Merchant")}
					className={"w-full"}
					showSearch
					haveAllValue
					allowClear
					value={getLabelByType(query.merchantName) || ""}
					optionRender={(item: Merchant, index: number) => (
						<Option value={`${item.fullName} ${item.username}`} key={index}>
							<p>{item.fullName}</p>
							<span className="text-sm text-[#95a5a6]">{item.username}</span>
						</Option>
					)}
				/>
			</div>
			<div>
				<p>{t`Status`}</p>
				<Select
					placeholder={t`Select status`}
					className="w-full"
					value={query.status}
					onChange={handleChangeStatus}
					allowClear
				>
					<Option value={null}>{t`All`}</Option>
					{Object.values(subscriptionTransactionStatus).map(el => (
						<Option key={el.value} value={el.value}>
							<span className={`text-[${el.color}]`}>{translate(el.name)}</span>
						</Option>
					))}
				</Select>
			</div>
			<div>
				<p>{t`Created date`}</p>
				<RangePicker
					className="w-full"
					value={[
						startDate ? moment(startDate) : null,
						endDate ? moment(endDate) : null,
					]}
					format="YYYY-MM-DD"
					allowEmpty={[true, true]}
					allowClear
					onChange={handleChangeRangeDate}
				/>
			</div>
			<div className="flex justify-between">
				<Button
					icon={<UndoOutlined />}
					className="flex items-center self-end rounded"
					onClick={handleReset}
				>
					{t`Reset`}
				</Button>
			</div>
		</div>
	);
};

export default Search;
